/* eslint-disable no-console */
import serverTime from 'utils/server-time';
import trackerDatalab from 'utils/tracker-datalab';

import wisdomStandaloneLoader from '../apps/hs-app-wisdom/wisdom-standalone-loader';

serverTime.init();
trackerDatalab.init('body');

try {
    wisdomStandaloneLoader.load();
} catch (e) {
    console.error('[hs-app-wisdom] failed to initialize standalone shell', e);
}
